"use client";
import { HomepageTopAd, MobileAdUnit, SidebarAd } from "../../AdsBox/AdsBox";
import NewsCard from "../../Helper/NewsCard";
import SmallImagesNewsCard from "../../Helper/SmallImagesNewsCard";
import { useIsMobile } from "@/app/Hooks/useIsMobile";
import { useRouter } from "next/navigation";
import { useSearchParams } from "next/navigation";

const TopHindiNews = ({ topHindiNewsData }) => {
  const allNews = topHindiNewsData || [];
  const isMobile = useIsMobile();
  const searchParams = useSearchParams();
  const router = useRouter();

  // DATA DISTRIBUTION
  const firstNews = allNews[0];
  const leftNews = allNews.slice(1, 12); // 11 items
  const middleNews = allNews.slice(12, 27); // 15 items
  const rightNews = allNews.slice(27, 42); // 11 items

  // preview redirect
  const postId = searchParams.get("p");
  const preview = searchParams.get("preview");

  if (postId && preview === "true") {
    router.replace(`/preview?p=${postId}&preview=true`);
  }

  return (
    <>
      {/* <div className="block md:hidden">
        <MobileAdUnit />
      </div>

      <div className="hidden md:block">
        <HomepageTopAd />
      </div> */}

      <div className="grid grid-cols-1 lg:grid-cols-3 my-20 lg:space-x-6">
        {/* LEFT COLUMN */}
        <div className="space-y-6">
          {firstNews && (
            <NewsCard
              title="Hindi News (हिंदी न्यूज़)"
              subtitle={firstNews?.title}
              media_details={firstNews?.media_details?.sizes}
              imageUrl={firstNews?.thumbnail_large}
              imageAlt={firstNews?.thumbnail_alt}
              titleClassName="!font-extrabold"
              showDot
              dotColor="bg-orange-500"
              imageClassName="w-[381px] h-[250px]"
              subtitleClassName="!text-[18px]"
              href={firstNews?.permalink}
              isVideo={firstNews?.is_video}
              titleAs="h1"
              fetchPriority="high"
              loading="eager"
              decoding="async"
            />
          )}

          {leftNews.map((item, index) => (
            <SmallImagesNewsCard
              key={item.id || index}
              subtitle={item.title}
              image={item?.thumbnail}
              // media_details={item?.media_details?.sizes}
              imageAlt={item?.thumbnail_alt}
              href={item.permalink}
              isVideo={item?.is_video}
              subtitleAs="h2"
              subtitleProps={{ className: "cursor-pointer" }}
              imagePriority={true}
              loading="lazy"
              decoding="async"
            />
          ))}
        </div>

        {/* MIDDLE COLUMN – 15 ITEMS */}
        <div className="space-y-5 mt-5 lg:mt-0">
          {middleNews.map((item, index) => (
            <SmallImagesNewsCard
              key={item.id || index}
              subtitle={item.title}
              image={item?.thumbnail}
              imageAlt={item?.thumbnail_alt}
              // media_details={item?.media_details?.sizes}
              href={item.permalink}
              isVideo={item?.is_video}
              subtitleProps={{ className: "cursor-pointer" }}
              imagePriority={true}
              loading="lazy"
              decoding="async"
            />
          ))}
        </div>

        {/* RIGHT COLUMN – 11 ITEMS */}
        <div className="space-y-5">
          {/* <div className="mt-5 lg:mt-0">
            {isMobile ? <MobileAdUnit /> : <SidebarAd />}
          </div> */}
          {rightNews.map((item, index) => (
            <SmallImagesNewsCard
              key={item.id || index}
              subtitle={item.title}
              image={item?.thumbnail}
              // media_details={item?.media_details?.sizes}
              imageAlt={item?.thumbnail_alt}
              href={item.permalink}
              isVideo={item?.is_video}
              subtitleProps={{ className: "cursor-pointer" }}
              imagePriority={true}
              loading="lazy"
              decoding="async"
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default TopHindiNews;
